var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "1.73389",
          y: "1.17969",
          width: "18.5",
          height: "18.1274",
          rx: "1.25",
          stroke: "white",
          "stroke-width": "1.5"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.5962 3.97314L15.2581 6.80845L12.5962 9.64382",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "14.5078",
          y1: "6.87305",
          x2: "7.45925",
          y2: "6.8731",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.37158 16.5137L6.70972 13.6784L9.37158 10.843",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "7.45996",
          y1: "13.6138",
          x2: "14.5085",
          y2: "13.6137",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }